function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, forwardRef } from "react";
import styled, { css } from "styled-components";
import { Text } from "sprout-ui-primitives";
import { media } from "sprout-ui-theme";
import Divider from "sprout-ui-dom/dist/Divider";
import { ItemMemberLevel } from "sprout-graphql";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import { useSetItemsArchived, useSetItemsDeleted } from "@sprout/client-graphql";
import useDeleteItems from "@sprout/client-graphql/dist/mutations/useDeleteItems";
import { useNavigationListContext } from "@sprout/list-navigation";
import { Card as BaseCard } from "@sprout/client-components/dist/Card";
import { useMergeRefs } from "sprout-hooks";
import { hexes } from "../TopicPageEditorDivider/colors";
import TopicPageDividerMenu from "./TopicPage_Divider_Menu";
const Card = styled(BaseCard)`
  display: flex;
  align-items: center;

  cursor: pointer;

  *:not(button) {
    pointer-events: none;
  }

  ${media.target("pointer")} {
    &:hover {
      .TopicPageDividerMenu {
        display: inline-flex;
      }
    }
  }

  ${({ isPartOfTopic  })=>!isPartOfTopic && css`
      cursor: default;
    `}

  ${media.up("medium")} {
    padding: 10px 0;
  }
`;
const StyledText = styled(Text)`
  min-width: 0;
  overflow-wrap: break-word;
  word-wrap: break-word;
`;
const StyledDivider = styled(Divider)`
  flex: 1;
`;
const TopicPageDividerForwardedRef = /*#__PURE__*/ forwardRef(function TopicPageDivider(props, ref) {
    const { divider , dragProvided , isDragging , navigationItemHelpers  } = props;
    const { color  } = divider.display;
    const { rootTopicOrSelf , id , deletedAt , isExplicitlyArchived , isExplicitlyDeleted ,  } = divider;
    const { memberLevel , owner  } = rootTopicOrSelf || {};
    const currentUser = useCurrentUser();
    const isCurrentUser = (owner === null || owner === void 0 ? void 0 : owner.id) === (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id);
    const isPartOfTopic = memberLevel && [
        ItemMemberLevel.Owner,
        ItemMemberLevel.Admin
    ].includes(memberLevel) || memberLevel === ItemMemberLevel.Contributor && isCurrentUser;
    const mergedRefs = useMergeRefs(ref, // eslint-disable-next-line @typescript-eslint/unbound-method
    dragProvided === null || dragProvided === void 0 ? void 0 : dragProvided.innerRef);
    // archive
    const nextIsExplicitlyArchived = !isExplicitlyArchived;
    const setItemsArchived = useSetItemsArchived();
    const archiveDivider = useCallback(()=>{
        setItemsArchived({
            items: [
                divider
            ],
            isExplicitlyArchived: nextIsExplicitlyArchived
        });
    }, [
        divider,
        nextIsExplicitlyArchived,
        setItemsArchived
    ]);
    // soft delete
    const nextIsExplicitlyDeleted = !isExplicitlyDeleted;
    const setItemsDeleted = useSetItemsDeleted();
    const trashDivider = useCallback(()=>{
        setItemsDeleted({
            items: [
                divider
            ],
            isExplicitlyDeleted: nextIsExplicitlyDeleted
        });
    }, [
        divider,
        nextIsExplicitlyDeleted,
        setItemsDeleted
    ]);
    // delete
    const deleteItems = useDeleteItems();
    const deleteDivider = useCallback(()=>{
        deleteItems({
            itemIds: [
                id
            ],
            type: "Leaf divider"
        });
    }, [
        deleteItems,
        id
    ]);
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const { dispatchCommand  } = useNavigationListContext();
    const handleDividerEdit = useCallback(()=>{
        dispatchCommand("FOCUS_DIVIDER", divider);
    }, [
        dispatchCommand,
        divider
    ]);
    const handleDividerClick = useCallback((event)=>{
        if (event.target !== event.currentTarget) return;
        handleDividerEdit();
    }, [
        handleDividerEdit
    ]);
    return /*#__PURE__*/ _jsxs(Card, _objectSpread({
        isActive: navigationItemHelpers.isActive
    }, dragProvided && _objectSpread({}, dragProvided.draggableProps, dragProvided.dragHandleProps), {
        ref: mergedRefs,
        isDragging: isDragging,
        isPartOfTopic: isPartOfTopic,
        onClick: handleDividerClick,
        children: [
            /*#__PURE__*/ _jsx(StyledText, {
                fontWeight: "bold",
                pr: "16px",
                lineHeight: "24px",
                children: divider.title || "No title"
            }),
            /*#__PURE__*/ _jsx(StyledDivider, {
                height: "2px",
                bg: hexes[color]
            }),
            isPartOfTopic && /*#__PURE__*/ _jsx(TopicPageDividerMenu, {
                isDeleted: !!deletedAt,
                isExplicitlyArchived: isExplicitlyArchived,
                isExplicitlyDeleted: isExplicitlyDeleted,
                //
                onEdit: handleDividerEdit,
                onArchive: archiveDivider,
                onTrash: trashDivider,
                onDelete: deleteDivider
            })
        ]
    }));
});
export default TopicPageDividerForwardedRef;
